module.exports = __webpack_public_path__ + "2c85b4dde184cce894b2653c36d7dd63.pdf";